// import * as Sentry from '@sentry/react';

export const logException = (err: Error, info: any = null) => {
    if (process.env.REACT_APP_ENV && ['production'].includes(`${process.env.REACT_APP_ENV}`)) {
        // Sentry.init({
        //     dsn: process.env.REACT_APP_RAVEN_CONFIG,
        //     environment: process.env.REACT_APP_ENV,
        //     normalizeDepth: 10,
        // });
        // Sentry.captureException(err, info);
        console.log('New Relic');
    }
};

const loggerObj = { logException };

export default loggerObj;
